module.exports = __webpack_public_path__ + "img/software_img4.fccd646b.png";